module.exports = "/images/cert_none.90d9b.png";